var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C123.451 16 16 123.451 16 256S123.451 496 256 496S496 388.549 496 256S388.549 16 256 16ZM384 360C384 373.25 373.25 384 360 384S336 373.25 336 360V226.219L275.453 310.047C266.422 322.547 245.578 322.547 236.547 310.047L176 226.219V360C176 373.25 165.25 384 152 384S128 373.25 128 360V152C128 141.594 134.719 132.359 144.609 129.172C154.469 125.922 165.359 129.484 171.453 137.953L256 255.016L340.547 137.953C346.641 129.484 357.437 125.922 367.391 129.172C377.281 132.359 384 141.594 384 152V360Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleM);
export default __webpack_public_path__ + "static/media/circle-m.1d7c880d76011d0553036d5961e08381.svg";
export { ForwardRef as ReactComponent };